import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustBadges = () => {
  const badges = [
    {
      id: 1,
      icon: 'Shield',
      label: 'SSL Secured',
      description: 'Bank-level encryption'
    },
    {
      id: 2,
      icon: 'Award',
      label: 'Certified Coaching',
      description: 'Professional training methods'
    },
    {
      id: 3,
      icon: 'Lock',
      label: 'Privacy Protected',
      description: 'Your data stays private'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-8 pt-8 border-t border-border">
      {badges?.map((badge) => (
        <div key={badge?.id} className="flex flex-col items-center text-center gap-2">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
            <Icon name={badge?.icon} size={20} color="var(--color-primary)" />
          </div>
          <div>
            <p className="text-sm font-semibold text-foreground">{badge?.label}</p>
            <p className="text-xs text-muted-foreground">{badge?.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TrustBadges;